import { LinearProgress } from "@mui/material";
import Container from "components/common/CustomContainer";
import Timing from "components/common/Timing";
import Typography from "components/common/Typography";
import { useNavigate } from "react-router-dom";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";
import { getHoursAndMin } from "utils/CommonFunctions";
import PlanBadge from "../dashboard/PlanBadge";

const PlanOverview = (props: any) => {
  const navigate = useNavigate();
  const totalCards = props?.inProgressCards + props?.cardsCompleted + props?.cardBacklog;
  const cardsCompletedPercent = totalCards > 0 ? Math.round((props?.cardsCompleted / totalCards) * 100) : 0;
  return (
    <Container className="my_plans-card" onClick={() => navigate(`/myplandetails/${props?.id}`)}>
      <div className="my_plans-card-top">
        <div className="my_plans-card-top-badge">
          <PlanBadge data={props} />
        </div>
        <div>
          <Typography component={"div"} variant="body2" color={colors.Neutral.Neutral400} sx={{ marginRight: "auto" }}>
            <Timing duration={getHoursAndMin(props?.remainingPlanDuration)} />
          </Typography>
        </div>
      </div>
      <div className="my_plans-card-bottom">
        <Typography color={tokens.Text.General.Secondary} variant="body2" className="text-left ellipse-two plan-name">
          {props?.name}
        </Typography>
        <div className="my_plans-card-progress-container">
          <LinearProgress variant="determinate" value={cardsCompletedPercent} />
          <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
            {cardsCompletedPercent}%
          </Typography>
        </div>
      </div>
    </Container>
  );
};

export default PlanOverview;
